import { render, staticRenderFns } from "./HomeFreeGift.vue?vue&type=template&id=ba1bc094&scoped=true"
import script from "./HomeFreeGift.vue?vue&type=script&lang=js"
export * from "./HomeFreeGift.vue?vue&type=script&lang=js"
import style0 from "./HomeFreeGift.vue?vue&type=style&index=0&id=ba1bc094&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba1bc094",
  null
  
)

export default component.exports